import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Performance',
    [Tab.NewCustomers]: 'New Restaurants',
    [Tab.CustomerHealth]: 'Customer Health',
    [Tab.LiveAndInactive]: 'Live and Inactive',
    [Tab.BillingHealth]: 'Billing Health',
  },
  labels: {
    sales_manager: 'Sales Manager',
  },
  performance_tab: {
    table_columns: {
      name: 'Name',
      sales_manager: 'Sales Manager',
      orders: 'Orders',
      sales: 'Sales',
      previous_month_sales: 'Previous Month Revenue',
    },
    labels: {
      sales_volume: 'Sales Volume:',
      all: 'All',
      click_to_sort: 'Click to sort',
      no_data: 'No data',
    },
    toasts: {
      failed_to_load_data: 'Failed to load data',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Name',
      sales_manager: 'Sales Manager',
      orders: 'Orders',
      sales: 'Sales',
      days_live: 'Days Live',
      early_performance: 'Early Performance',
    },
    labels: {
      click_to_sort: 'Click to sort',
      no_data: 'No data',
      only_with_early_performance: 'Only with early performance: ',
      early_performance_yes: '✔️ Yes',
      early_performance_no: '✗ No',
    },
    toasts: {
      failed_to_load_data: 'Failed to load data',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Sales Tiers',
      payments_ratio: 'Payments Ratio',
    },
    dataset_labels: {
      negative: 'Negative ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Good ({{values}})',
      excellent: 'Excellent ({{values}})',
    },

    companies_preview_modal: {
      title: 'Restaurants Preview',
      table_columns: {
        name: 'Name',
        sales_manager: 'Sales Manager',
        orders: 'Orders',
        sales: 'Sales',
        total_payments: 'Total Payments',
        payments_ratio: 'Payments Ratio',
      },
      labels: {
        close: 'Close',
        click_to_sort: 'Click to sort',
        no_data: 'No data',
      },
    },
    toasts: {
      failed_to_load_data: 'Failed to load data',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Live',
      no_orders: 'No orders',
      no_conversion: 'No conversion',
    },
    toasts: {
      failed_to_load_data: 'Failed to load data',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Billing Type',
        options: {
          [BillingTypeOptions.Subscription]: 'Subscription',
          [BillingTypeOptions.Manual]: 'Other',
        },
      },
      high_risk_only: {
        label: 'Only high risk customers',
      },
    },
    fields: {
      name: 'Name',
      live_from: 'Live from',
      billing_mode: {
        title: 'Billing source',
        options: {
          [BillingMode.Stripe]: 'Payment method',
          [BillingMode.InternalInvoicing]: 'Sales',
        },
      },
      trial_ends_at: 'Trial end',
      last_failed_invoice_amount: 'Last failed invoice amount',
      failed_payments_count: 'Failed payments count',
    },
    tags: {
      is_high_billing_risk_customer: 'High billing risks',
    },
    toasts: {
      failed_to_load_data: 'Failed to load data',
    },
  },
};
